import e from "react";
const r = (t) => e.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 14", width: "14", height: "14" }, t),
  e.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    e.createElement(
      "g",
      null,
      e.createElement("path", { d: "M1483,591 C1486.86575,591 1490,594.13425 1490,598 C1490,601.86575 1486.86575,605 1483,605 C1479.13425,605 1476,601.86575 1476,598 C1476,594.13425 1479.13425,591 1483,591 Z M1486.138,600.195333 L1483.94267,598 L1486.138,595.80467 C1486.39867,595.544 1486.39867,595.12267 1486.138,594.862 C1485.87733,594.60133 1485.456,594.60133 1485.19533,594.862 L1483,597.057333 L1480.80467,594.862 C1480.544,594.60133 1480.12267,594.60133 1479.862,594.862 C1479.60133,595.12267 1479.60133,595.544 1479.862,595.80467 L1482.05733,598 L1479.862,600.195333 C1479.60133,600.456 1479.60133,600.877333 1479.862,601.138 C1479.992,601.268 1480.16267,601.333333 1480.33333,601.333333 C1480.504,601.333333 1480.67467,601.268 1480.80467,601.138 L1483,598.942667 L1485.19533,601.138 C1485.32533,601.268 1485.496,601.333333 1485.66667,601.333333 C1485.83733,601.333333 1486.008,601.268 1486.138,601.138 C1486.39867,600.877333 1486.39867,600.456 1486.138,600.195333 Z", transform: "translate(-1476 -591)" })
    )
  )
);
r.displayName = "CircleX14x14";
export {
  r as I
};
//# sourceMappingURL=CircleX14x14-Dx82f2vj.mjs.map
